<script setup>
import { defineProps, computed, ref } from 'vue';
import { useState } from 'vuex-composition-helpers';

import FormHeader from '@/components/FormHeader.vue';
import FormControls from '@/components/FormControls.vue';

const props = defineProps({
  hideHeader: {
    type: Boolean,
    default: false
  },
  staticForm: {
    type: Boolean,
    default: false
  },
  formCampaignSettings: {
    type: Object,
    default: () => null
  }
});

const { settings: defaultSettings } = useState('publicOrgSettings', ['settings']);
const { settings: campaignSettings } = useState('campaign', ['settings']);
const settings = computed(() => {
  if (props.formCampaignSettings) {
    return props.formCampaignSettings;
  }
  return props.staticForm ? defaultSettings.value : campaignSettings.value;
});

const primaryColorVar = computed(() => {
  return {
    '--primary-color-values': settings.value.themeColor,
    '--primary-color': 'var(--primary-color-values)',
    '--primary-color-opacity-values': `color-mix(in srgb, ${settings.value.themeColor} 20%, white)`,
    '--primary-color-opacity': 'var(--primary-color-opacity-values)',
    '--secondary-color-values': settings.value.headerColor,
    '--secondary-color': 'var(--secondary-color-values)',
    '--primary-color-text-values': settings.value.themeTextColor,
    '--primary-color-text': 'var(--primary-color-text-values)',
    '--accent-text-color':
      settings.value.themeTextColor && settings.value.themeTextColor !== '#ffffff' ? settings.value.themeTextColor : settings.value.themeColor // If themeTextColor is default value '#ffffff', use themeColor
  };
});

const frameMaxWidth = computed(() => {
  if (props.staticForm) {
    return '100%';
  }

  return '275px';
});

const { slideDirection, isPages } = useState(['slideDirection', 'isPages']);
const isTransitioning = ref(false);
</script>

<template>
  <div :style="[primaryColorVar, { minWidth: frameMaxWidth }]" :data-locale="$i18n.locale">
    <div :class="{ 'bg-secondary': !staticForm, 'min-h-screen': !staticForm }" class="flex flex-col">
      <template v-if="!hideHeader">
        <form-controls />
        <form-header :static-form="staticForm" />
      </template>
      <div
        class="h-full flex flex-col flex-1 checkout-layout"
        :class="{ 'has-header': !hideHeader, 'static-form': staticForm, transitioning: isTransitioning, 'is-pages': isPages }"
      >
        <transition :name="slideDirection" @before-enter="isTransitioning = true" @after-enter="isTransitioning = false">
          <!-- <transition name="slide-left" mode="out-in"> -->
          <slot />
        </transition>
      </div>
    </div>
  </div>
</template>
